import Box from "@mui/material/Box";
import React, { FC } from "react";
import { usePageDetails } from "../../context";
import { StyledPrimaryButton, StyledSecondaryButton } from "./styled";
import useRolePermission from "entities/auth/hooks/useRolePermission";

const ActionButtons: FC = () => {
  const {
    isSubmitting,
    disabled,
    handleSaveDraft,
    handleSaveActive,
    handleSaveTranslations,
  } = usePageDetails();
  const { allowed: hasWriteTranslationsAccess } = useRolePermission("brandsAndPages:translations:write");
  const { allowed: hasWriteAccess } = useRolePermission("brandsAndPages:write");

  if (!hasWriteAccess && !hasWriteTranslationsAccess) {
    return null;
  }

  if (!hasWriteAccess && hasWriteTranslationsAccess) {
    return (
      <Box gap="1rem" display="flex" flexDirection="row" alignItems="center">
        <StyledPrimaryButton
          title="Save"
          size="small"
          disabled={disabled}
          onClick={handleSaveTranslations}
          loading={isSubmitting}
        />
      </Box>
    );
  }

  return (
    <Box gap="1rem" display="flex" flexDirection="row" alignItems="center">
      <StyledSecondaryButton
        title="Save as draft"
        size="small"
        color="secondary"
        variant="outlined"
        disabled={disabled}
        onClick={handleSaveDraft}
        loading={isSubmitting}
      />
      <StyledPrimaryButton
        title="Save and Publish"
        size="small"
        disabled={disabled}
        onClick={handleSaveActive}
        loading={isSubmitting}
      />
    </Box>
  );
};

export default ActionButtons;
